import { ProductKey } from "@/components/signup/utils";
import { useUserContext } from "@/components/user-context";

import {
    CFindEmbeddedSignupForm,
    LoggedInForm,
    ConfluenceFeaturesPageEmbeddedSignupForm,
    DefaultEmbeddedSignupForm
} from "./embedded-variants";

import type { ConfluenceAnchorVariant } from "../";

export const variants = {
    "paid-lp-conf-features": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-conf-features" />
    ),
    "paid-lp-confl-projectmgmt": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-confl-projectmgmt" />
    ),
    "paid-lp-confl-documentation": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-confl-documentation" />
    ),
    "paid-lp-confl-template": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-confl-template" />
    ),
    "anchor-lp-conf-automation": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-automation" />
    ),
    "anchor-lp-conf-collaboration": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-collaboration" />
    ),
    "anchor-lp-conf-teamwork": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-teamwork" />
    ),
    "anchor-lp-conf-work-management": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-work-management" />
    ),
    "anchor-lp-conf-competitors": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-competitors" />
    ),
    "default": <DefaultEmbeddedSignupForm />,
    "confluence-default": <CFindEmbeddedSignupForm />
};

export const EmbeddedSignupForm = ({ pageId }: { pageId: string }) => {
    const { product, user } = useUserContext();

    if (user.isUserLoggedIn) {
        return <LoggedInForm />;
    }

    let variantName: ConfluenceAnchorVariant = "default";

    if (product?.key === ProductKey.CONFLUENCE) {
        variantName = "confluence-default";
    }

    if (pageId in variants) {
        variantName = pageId as ConfluenceAnchorVariant;
    }

    return variants[variantName];
};
